export default "__VITE_ASSET__qt6rb91M__"